var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-5 mb-xl-5"},[_c('md-progress-spinner',{attrs:{"md-mode":"indeterminate","md-diameter":30,"md-stroke":3}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }